document.querySelectorAll('.cdna-bp').forEach((root) => {
  const pager = root.querySelector('.cdna-bp__pager');
  const pages = root.querySelectorAll('.cdna-bp__page');
  const dots = root.querySelectorAll('.cdna-bp__dot');
  const hint = root.querySelector('.cdna-bp__swipe-hint');
  if (!pager || pages.length < 2) return;

  const pageStep = () => {
    if (pages.length < 2) return pager.clientWidth;
    return pages[1].offsetLeft - pages[0].offsetLeft;
  };

  const setActiveDot = (index) => {
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  };

  let hintDismissed = false;
  const dismissHint = () => {
    if (hintDismissed || !hint) return;
    hintDismissed = true;
    hint.style.opacity = '0';
  };

  let ticking = false;
  pager.addEventListener('scroll', () => {
    dismissHint();
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const step = pageStep();
      const index = step > 0 ? Math.round(pager.scrollLeft / step) : 0;
      setActiveDot(Math.min(index, dots.length - 1));
      ticking = false;
    });
  }, { passive: true });
});
